import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const ROLE_CONSTANTS = {
  ROLE_PATH: "/roles",
  SERVICE_TEXT: "Servicio",
  VIEWS: "Pantallas",
  PAGE_TITLE: "Roles",
  ADD_PAGE_TITLE: "Agregar rol",
  EDIT_PAGE_TITLE: "Editar rol",
  PAGE_TITLE_SEARCH: "Consulta de roles",
  PAGE_TITLE_CREATE: "Administrar roles",
  ENDPOINTS_TEXT: "Acciones",
  VIEWS_ALLOWED_TEXT: "Pantallas",
  PERMISSION_TEXT: "Permisos",
  ADD_ENDPOINT: "Agregar permiso acciones",
  ADD_VIEW: "Agregar permiso pantalla",
  UPDATE_TEXT: "Actualizar",
  ROLE_NAME: "Nombre rol*",
  ALL_IDS_TEXT: "allId",
  ID_REF_GO_TO: "sidePanelForm",
  GRAPH: {
    TITLE: "Roles",
    NAME_KEY_DATA: "roleChartInfo"
  },
  BUTTON: {
    ADD_ROLE: "Crear rol",
    CLOSE_ROLE: "Cancelar"
  },
  DELETE_MODAL: {
    TITLE: "Eliminar rol",
    TEXT: "Ingrese la razón por la cual va a deshabilitar el rol:"
  },
  UPDATE_MODAL: {
    TITLE: "Actualizar",
    TEXT: "¿Está seguro que desea Actualizar?"
  },
  MESSAGES: {
    ROLE_CREATED: "Rol creado correctamente",
    ROLE_ALREADY_EXIST: "El nombre de rol ya existe",
    ROLE_UPDATED: "Rol actualizado correctamente",
    ROLE_DELETED: "Rol eliminado correctamente",
    ROLE_USED: "El rol está en uso, no se puede eliminar",
    CLOSE_VIEW: "se debe guardar o cancelar la vista"
  },
  PERMISSION_SIDE_PANEL_CARD: {
    TITLE: "Permisos panel lateral",
    TEXT:
      "Configura las acciones principales que este rol podrá encontrar en el panel derecho"
  },
  PERMISSION_CARD: {
    TITLE: "Permisos",
    TEXT:
      "Recuerda que algunas acciones se comparten entre las pantallas, si modificas su configuración los cambios se verán reflejadas en todas.",
    BUTTON_TEXT: "Agregar pantalla",
    SEARCH_SCREEN: "Buscar pantalla"
  },
  LANDING_CARD: {
    TITLE: "Landing principal",
    TEXT: "Estas son las funciones podrás visualizar",
    TEXT_VOID: "No hay cards por mostrar en la landing"
  },
  ADMIN_ROL_CARD: {
    TITLE: "Administrar roles",
    TEXT: "Información general",
    ROLE_NAME: "Nombre rol"
  },
  ASSIGN_PERMISSION_CARD: {
    TITLE_TABLE: [
      "Nombre acción",
      "Crear",
      "Consultar",
      "Modificar",
      "Eliminar"
    ],
    BUTTON_EDIT: { TEXT: "Editar" },
    BUTTON_DELETE: { TEXT: "Eliminar" },
    BUTTON_SAVE: { TEXT: "Guardar" },
    BUTTON_CLOSE: { TEXT: "Cancelar" }
  },
  REFRESH_DATA: "refreshData",
  CLOSE_MODAL: "closeModal",
  CARD_VIEW: "cardView"
};

export const ALL_IDS = ["getId", "postId", "putId", "deleteId"];
export const ENDPOINTS_COLORS = ["#F7A072", "#69D1C5", "secondary", "primary"];

export const ROLE_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    placeholder: "Nombre de Role",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE,
    default: true
  },
  {
    name: "Estado",
    placeholder: "Estado de Role",
    key: "state",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
];

export const FORM_FILTERS_ROLE: Filter[] = [
  {
    mainFilterKey: "forms",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    initial: true,
    secondaryFilters: ROLE_SECONDARY_FILTERS
  }
];
export const SEARCH_CONTEXT_DESCRIPTIONS = ["state"];
export const FILTER_VOIDED_DEFAULT = ["false"];

export const ROLES_ACCESS = {
  GET: "consultar roles",
  POST: "crear roles",
  PUT: "modificar roles",
  DELETE: "eliminar roles"
};

export const EVENT_VALID_NAME_FIELD = "nameIsValid";
